export const WORKER_URL = "https://unpkg.com/pdfjs-dist@3.6.172/build/pdf.worker.min.js";